module.exports = __webpack_public_path__ + "static/media/video-player-evaluation.afeed9a0.jpg";